import React, { useState } from 'react';
import AuthField from './AuthField';
import Icon from '../../components/Icon';
import { Alert, Spinner } from '../../components/ui';
import { api } from '../../lib/api';

const MIN_PASSWORD = 6;

export default function ResetPasswordForm({ resetToken, onDone }) {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < MIN_PASSWORD) {
      setError(`Password must be at least ${MIN_PASSWORD} characters.`);
      return;
    }
    if (password !== confirm) {
      setError('Those passwords do not match.');
      return;
    }
    setError('');
    setBusy(true);
    try {
      await api.post('/api/auth/reset-password', { token: resetToken, password });
      setDone(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <div className="auth-notice">
        <div className="auth-notice-icon">
          <Icon name="checkCircle" size={26} />
        </div>
        <div className="auth-notice-title">Password updated</div>
        <p className="auth-notice-text">You can now sign in with your new password.</p>
        <button type="button" className="btn btn-gradient btn-lg btn-block" onClick={onDone}>
          Sign in
        </button>
      </div>
    );
  }

  return (
    <form className="auth-form" onSubmit={submit} noValidate>
      <AuthField
        label="New password"
        icon="lock"
        type="password"
        value={password}
        onChange={setPassword}
        placeholder={`At least ${MIN_PASSWORD} characters`}
        autoComplete="new-password"
        required
      />
      <AuthField
        label="Confirm password"
        icon="lock"
        type="password"
        value={confirm}
        onChange={setConfirm}
        placeholder="Repeat your new password"
        autoComplete="new-password"
        required
      />
      {error && <Alert kind="error">{error}</Alert>}
      <button type="submit" className="btn btn-gradient btn-lg btn-block" disabled={busy}>
        {busy ? <Spinner label="Updating password" /> : 'Update password'}
      </button>
    </form>
  );
}
